import React from 'react'

export default function WebingoSite() {
  return (
    <div className='webingo_site_container'>
        explore
    </div>
  )
}
